import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3300/api";

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const GET = (url, { params = {}, headers = {}, cancelToken } = {}) =>
  apiClient.get(url, { params, headers, cancelToken });

export const POST = (url, { payload = {}, params = {}, headers = {} } = {}) =>
  apiClient.post(url, payload, { params, headers });

export const PUT = (url, { payload = {}, params = {}, headers = {} } = {}) =>
  apiClient.put(url, payload, { params, headers });

export const PATCH = (url, { payload = {}, params = {}, headers = {} } = {}) =>
  apiClient.patch(url, payload, { params, headers });

export const DELETE = (url, { payload = {}, params = {}, headers = {} } = {}) =>
  apiClient.delete(url, { data: payload, params, headers });
